const vGravityFormsMods = () => {
		window.jQuery(document).on('gform_post_render', () => {
		const gForms = document.querySelectorAll('form .gform-body');
		if(gForms) {
			Array.from(gForms).forEach(gForm => {
				const gFormSelectWrappers = gForm.querySelectorAll('.gfield--type-select, .ginput_address_country, .gfield--type-option');

				Array.from(gFormSelectWrappers).forEach(gFormSelect => {
					const selectEl = gFormSelect.querySelector('select');
					const selectedValue = selectEl.value;

					// Dropdown Btn
					const dropdownBtn = document.createElement('div');
					dropdownBtn.classList.add('v-big-form__c-select-btn')

					// Dropdown Wrapper
					const styleDropdownWrapper = document.createElement('div');
					styleDropdownWrapper.classList.add('v-big-form__c-select');
					styleDropdownWrapper.tabIndex = 0;

					const selectLabel = gFormSelect.querySelector('label.gfield_label, label.gform-field-label');
					const styledDropdown = document.createElement('ul');
					styledDropdown.classList.add('v-big-form__c-select-options')
					styleDropdownWrapper.appendChild(dropdownBtn);
					styleDropdownWrapper.appendChild(styledDropdown);

					[...selectEl.options].forEach((option) => {
						if(option.value) {
							const listItem = document.createElement('li');
							listItem.classList.add('v-big-form__c-select-option');
							listItem.textContent = option.value;
							if(selectedValue === option.value) {
								// selectLabel.textContent = option.text;
								selectEl.value = option.value;
								listItem.classList.add('selected');
							}
							styledDropdown.appendChild(listItem);

							listItem.addEventListener('click', () => {
								const selectedItem = styledDropdown.querySelector('li.selected');
								if(selectedItem) {
									selectedItem.classList.remove('selected');
								}

								selectLabel.textContent = option.text;
								selectEl.value = option.value;
								selectEl.dispatchEvent(new Event('change', { bubbles: true }));
    						selectEl.dispatchEvent(new Event('input', { bubbles: true }));
								listItem.classList.add('selected');
							});
						}
					});

					// Close fake dropdown
					const options = styledDropdown.querySelectorAll('li');
					styleDropdownWrapper.addEventListener('click', () => {
						styleDropdownWrapper.classList.toggle('active');
						if(!selectEl.value) {
							options.forEach(option => option.classList.remove('selected'));
						}
					});

					// Close fake dropdown clicking away
					document.addEventListener('click', (event) => {
						if (!styleDropdownWrapper.contains(event.target)) {
							styleDropdownWrapper.classList.remove("active");
						}

						if(!selectEl.value) {
							options.forEach(option => option.classList.remove('selected'));
						}
					});

					selectEl.insertAdjacentElement('afterend', styleDropdownWrapper);

				});
			});

			/*
			|
			| Add search on typing to dropdowns
			|
			*/
			const dropdown = document.querySelectorAll('.v-big-form__c-select');
			dropdown.forEach(drop => {
				const options = drop.querySelectorAll('.v-big-form__c-select-options li');
				let searchTerm = '';
				let searchTimeout;
				drop.addEventListener('keydown', (e) => {
					// Allow only letters, numbers, and space
					if (/^[a-z0-9 ]$/i.test(e.key)) {
						searchTerm += e.key.toLowerCase();
						clearTimeout(searchTimeout);
						searchTimeout = setTimeout(() => {searchTerm = ''}, 500);

						options.forEach(option => option.classList.remove('selected'));
						[...options].every(option => {
							if (
								!option.classList.contains('selected') &&
								option.textContent.toLowerCase().startsWith(searchTerm)
							) {
								option.classList.add('selected');
								option.scrollIntoView({ block: 'nearest' });
								return false;
							}
							return true;
						});
					}
				});
			});

		}
	});

}

export default vGravityFormsMods;
